import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export interface Subscription {
  id: number;
  sku: string;
  start_date: string;
  end_date: string;
  cancel_date: string;
  auto_renew: boolean;
  suspended: boolean;
  billing_channel: string;
  available_stt_budget: string;
  available_stt_units: number;
  available_alignment_budget: string;
  available_alignment_units: number;
  available_translation_budget: string;
  available_translation_characters: number;
  custom_model_yearly_limit: number | null;
  custom_model_yearly_used: number;
  custom_model_yearly_remaining: number | null;
  // Per-training-round charge for this subscription's plan. Null when the
  // plan is priced differently or has no per-round charge (api-scriptix
  // #2211 addition). Panel renders this next to "rounds used".
  automatic_training_unit_cost?: string | number | null;
}

export interface SubscriptionResponse {
  count: number;
  total_results: number;
  result: Subscription;
}

export const useGetSubscription = (id: string | undefined) => {
  const fetchSubscription = async (id: string | undefined) => {
    const response = await Axios.get<SubscriptionResponse>(
      `${GET_URL(id).subscription}`
    );
    return response.data;
  };

  return useQuery<SubscriptionResponse, AxiosError<BaseError>>(
    ['subscription', id],
    () => fetchSubscription(id),
    {
      enabled: !!id
    }
  );
};
